<template>
  <div class="mainContPage">
    <div class="top-logo" :class="{ postnord: brand === 'postnord'}">
      <img :src="brandSrc" alt="">
    </div>
    <div class="search-result-box">
      <div v-if="!['postnord', 'Yusen'].includes(brand)" class="radio-type">        <el-radio v-model="trackType" label="">{{ $t('trackingNo') }}</el-radio>
        <el-radio v-model="trackType" label="0">{{ $t('consignmentId') }}</el-radio>
      </div>
      <SearchAndResults :track-type="trackType" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SearchAndResults from './SearchAndResults/index.vue'
import { common } from '@/api/requestUrl'
import { getCurrentAggregatorLogoInfo } from '@/api/user'
import baseUrl from '@/utils/baseUrl'
export default {
  components: {
    SearchAndResults
  },
  data() {
    return {
      baseURL: baseUrl,
      trackType: '',
      logoId: '', // 亮色logo
      iconLogoId: '' // icon
    }
  },
  computed: {
    ...mapGetters(['language', 'brand', 'token']),
    tenantId() {
      return this.$store.state.user.userInfo.tenantId
    },
    brandSrc() {
      // 如果配置了logoId使用配置的Id
      if (this.logoId) {
        return `${this.baseURL}${common.scanceImg}?imageId=${this.logoId}`
      } else {
        const brand = this.brand
        if (brand === 'eTower') {
          return require('@/assets/images/logo/eTower_normal.png')
        }
        if (brand === 'Yusen') {
          return require('@/assets/images/logo/Yusen2.png')
        }
        return require('@/assets/images/logo/' + brand + '.png')
      }
    }
  },
  watch: {
  },
  created() {
    if (!this.token) return
    getCurrentAggregatorLogoInfo(this.baseURL).then(res => {
      const { iconLogoId = '', logoId = '' } = res.data
      this.logoId = logoId
      this.iconLogoId = iconLogoId
      if (!iconLogoId) return
      this.$nextTick(() => {
        let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = `${this.baseURL}${common.scanceImg}?imageId=${iconLogoId}`
        document.getElementsByTagName('head')[0].appendChild(link)
      })
    })
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.mainContPage {
  flex: 1;
  .top-logo {
    padding-top: 20px;
    padding-bottom: 20px;
    text-align: center;
    img {
      height: 120px;
    }
    &.postnord {
      margin-top: -2px;
      margin-bottom: 15px;
      background-color: #0d234b;
      padding: 0;
      img {
        height: 48px;
      }
    }
  }
  .search-result-box {
    width: 1120px;
    margin: 0 auto;
  }
  .radio-type {
    text-align: left;
    padding-left: 230px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
}
</style>
